import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import makeStyles from '@mui/styles/makeStyles';
import { NavigationButton } from 'components/elements';
import { AccountPersonIcon } from 'components/elements/Icons';
import { routes } from 'const';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function UserAccountButton({ classes }) {
  const styles = useStyles();
  const iconClasses = cn(styles.userAccountButton, classes);
  const { t } = useTranslation('labels');
  return <NavigationButton classes={iconClasses} icon={<AccountPersonIcon />} link={routes.settings} label={t('settings')} />;
}

UserAccountButton.propTypes = {
  classes: PropTypes.string,
};

UserAccountButton.defaultProps = {
  classes: '',
};

export default UserAccountButton;
